import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { ButtonController } from '../../../Common/ButtonController';
import QuestConstants from '../../../Constants/QuestConstants';
import { GameLogic } from '../../../Logic/GameLogic';
import { GameModel, QuestStateEnum } from '../../../Models/GameModel';
import { Text } from 'pixi.js';
import { MiniGameTypeEnum } from '../../../Models/MiniGameModel';

export interface IQuestScreenControllerOptions {}

export class QuestScreenController extends AnimationBaseController {
    public $model: GameModel;

    private _dialogWidth: number = 0;
    private _hasChoice: boolean = false;

    private _questState = null;
    private questStep:number = 0;
    public constructor(
        @Inject private _options: IQuestScreenControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super('QuestScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.DIALOG_SCREEN_JSON,
            libraryName: 'dialog_window',
            childControllers: {
                btn_1: {
                    instanceName: 'button_1',
                    controller: ButtonController,
                    model: this.$model,
                    options: {
                        onClick: () => {
                            this._buttonAction(1);
                        },
                    },
                },
                btn_2: {
                    instanceName: 'button_2',
                    controller: ButtonController,
                    model: this.$model,
                    options: {
                        onClick: () => {
                            this._buttonAction(2);
                        },
                    },
                },
                btn_3: {
                    instanceName: 'button_3',
                    controller: ButtonController,
                    model: this.$model,
                    options: {
                        onClick: () => {
                            this._buttonAction(3);
                        },
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this._questState = QuestConstants[this.$model.questState];
        this._setTextDialog(this._questState);

        this._dialogWidth = this.width;
        this.questStep = 0;
        console.log('onInitialize', this.$model.currMiniGameType);
    }

    private _buttonAction(num: number): void {
        // const isLose = (this._questState[`button_${num}`].hasOwnProperty('isLose')) ? this._questState[`button_${num}`].isLose : false;
        const button = this.getButton(num);
        const isLose = this._checkAnswer(num);
        
        
        // console.log(button,this.questStep ,isLose);
        if (button.nextStep && !this._hasChoice) {
            this._setTextDialog(this._questState[`nextQuest${num}`]);
            this._hasChoice = true;
        } else {
            const state = this.$model.questState;
            console.log(isLose)
            this._gameLogic.hideQuestScreen();
            this._gameLogic.onMiniGameComplete(MiniGameTypeEnum[state],isLose);
            this._hasChoice = false;

            if (state == QuestStateEnum.departure) {
                this._gameLogic.showInfoScreen();
            }
        }
        if (button.nextStep)
            this.questStep += num;
    }

    private getButton(num: number){
        if (this.questStep){
            return this._questState[`nextQuest${this.questStep}`]['button_1'];
        }
        return this._questState[`button_${num}`];
    }

    private _checkAnswer(num: number): boolean {
       const button = this.getButton(num);

        /*
        if (button.answerText) {
            this._gameLogic.endScreenText(button.answerText);
        }
         */

        if (button.hasOwnProperty('isLose') && button.isLose) {
            this._gameLogic.onMiniGameFailed(this.$model.currMiniGameType);
            return true;
        }
        return false;
    }

    private _setTextDialog(state): void {
        this.setTextByQuery('title', `${state.title}`);

        if (state.button_3) {
            this.gotoAndStop(0);
            this.setTextByQuery('button_1.button_1', `${state.button_1.title}`);
            this.setTextByQuery('button_2.button_2', `${state.button_2.title}`);
            this.setTextByQuery('button_3.button_3', `${state.button_3.title}`);
        } else if (state.button_2) {
            this.gotoAndStop(1);
            this.setTextByQuery('button_1.button_1', `${state.button_1.title}`);
            this.setTextByQuery('button_2.button_2', `${state.button_2.title}`);
        } else {
            this.gotoAndStop(2);
            this.setTextByQuery('button_1.button_1', `${state.button_1.title}`);
        }
    }

    protected onResize(width: number, height: number, scale: number) {
        const scaleValue = width / scale / this._dialogWidth;

        this.y = height / scale / 2 - 200 * scaleValue;
        this.scaleX = scaleValue;
        this.scaleY = scaleValue;

        // this.x = width / scale / 2;
    }

    protected onUpdate(frameRate: number) {
        this.setTextCenter('button_1.button_1');
        this.setTextCenter('button_2.button_2');
        this.setTextCenter('button_3.button_3');
    }

    private setTextCenter(key): void {
        this.setPosYByQuery(
            key,
            -(this.getDisplayObjectByQuery(key)[0] as Text).height / 2
        );
    }
}
